import Vue from 'vue'
import Vuex from 'vuex'
import { util } from '../assets/js/util'

Vue.use(Vuex)
const state = {
  panoView: null,
  showPlugin: true,
  appId: '',
  isPreview: 0,
  entityId: util.getUrlParam('hotelId') || util.getUrlParam('entityId'),
  panoViewOverflowHidden: true,
  isModel: false
}

export default new Vuex.Store({
  state
})



// WEBPACK FOOTER //
// ./src/vuex/store.js